import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
import axios from 'axios';
import { MerChantModel } from '../../../models/merChantModel';
import { IMAGE_MERCHANT_ROOT_URL } from '../../../constants/imageUrl';
import { generateImageFileNameWithRandomName } from '../../../utils/generateImageFileName';
import { MerchantEnum } from '../../../enums/merchantEnum';
import {
  IMAGE_MERCHANT_URL,
  MERCHANT_STORE_CREATE,
  MERCHANT_STORE_UPDATE,
  MERCHANT_STORE_UPDATE_LOCATION,
} from '../../../lib/endpoints/merchant';
import { DeliveryFeeModel } from '../../../models/deliveryFee';
import { FIND_MANY_DELIVERY_FEE } from '../../../lib/endpoints/deliveryFee';
import provinceData from '../../../data/laos_provinces.json';
import { District } from '../../../models/district';
import { ProvinceModel } from '../../../models/province';
const dataProvinceFromJson: ProvinceModel[] = provinceData;

interface Props {
  onfetch: Function;
  onClose: VoidFunction;
  selectedMerchant: MerChantModel;
  selectMerchant: Function;
  merchantType: MerchantEnum;
}

export const useFormBranchManageControllers = ({
  onfetch,
  onClose,
  selectedMerchant,
  selectMerchant,
  merchantType,
}: Props) => {
  const { t } = useTranslation('global');
  const isAuth = useSelector((state: RootState) => state?.auth?.data);
  const [deliveryFeeData, setDeliveryFeeData] = useState<DeliveryFeeModel[]>([]);
  const [deliveryFeeValue, setDeliveryFeeValue] = useState<string>(null!);

  const [ban, setBan] = useState<boolean>(false);
  const [imageToShow, setImageToShow] = useState<any>(null!);
  const [imageFile, setImageFile] = useState<any>(null!);
  const [imageBannerToShow, setImageBannerToShow] = useState<string | null>('');
  const [imageBannerFile, setImageBannerFile] = useState<any>(null!);
  const [openConfirm, setOpenConfirm] = useState<boolean>(false);
  const [loadingConfirmButton, setLoadingConfirmButton] = useState<boolean>(false);
  const [errorMessage, setErrorMessage] = useState<string>(null!);
  const [tabMerchant, setTabMerchant] = useState<MerchantEnum>(MerchantEnum.Jiffy);

  const [provinceValue, setProvinceValue] = useState<string>(null!);
  const [districtsValue, setDistrictsValue] = useState<string>(null!);
  const [districtsData, setDistrictsData] = useState<District[]>([]);

  const createByUser = isAuth?.username;
  const merchantCode = useRef<HTMLInputElement>(null!);
  const nameLa = useRef<HTMLInputElement>(null!);
  const nameEn = useRef<HTMLInputElement>(null!);
  const abbName = useRef<HTMLInputElement>(null!);
  const merchantNo = useRef<HTMLInputElement>(null!);
  const latitude = useRef<HTMLInputElement>(null!);
  const longitude = useRef<HTMLInputElement>(null!);
  const province = useRef<HTMLInputElement>(null!);
  const district = useRef<HTMLInputElement>(null!);
  const village = useRef<HTMLInputElement>(null!);
  const phone = useRef<HTMLInputElement>(null!);

  const onBan = (newValue: boolean) => {
    setBan(newValue);
  };

  const handleSelectedCompany = (e: any) => {
    setTabMerchant(e.target.value);
  };

  const handleSelectDeliveryFee = (e: any) => {
    setDeliveryFeeValue(e.target.value);
  };

  const handleReset = () => {
    selectMerchant(null);
    setImageToShow(null);
    setImageBannerToShow(null);
    setImageBannerFile(null);
    setImageFile(null);
    nameLa.current.value = '';
    nameEn.current.value = '';
    abbName.current.value = '';
    merchantNo.current.value = '';
    latitude.current.value = '';
    longitude.current.value = '';
    province.current.value = '';
    district.current.value = '';
    village.current.value = '';
    phone.current.value = '';
  };

  const handleSelectImage = (e: any) => {
    const file = e.target.files[0];
    setImageFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageToShow(reader.result as string);
      }
    };
    reader.readAsDataURL(file);
    setImageToShow(file);
  };

  const handleSelectBannerImage = (e: any) => {
    const file = e.target.files[0];
    setImageBannerFile(file);
    const reader = new FileReader();
    reader.onload = () => {
      if (reader.readyState === 2) {
        setImageBannerToShow(reader.result as string);
      }
    };
    reader.readAsDataURL(file);
    setImageBannerToShow(file);
  };

  const handleValidateForm = (): boolean => {
    if (!(parseFloat(latitude.current.value) >= -90 && parseFloat(latitude.current.value) <= 90)) {
      setErrorMessage('Latitude ຕ້ອງຢູ່ລະຫວ່າງ -90 - 90');
      return false;
    }
    if (
      !(parseFloat(longitude.current.value) >= -180 && parseFloat(longitude.current.value) <= 180)
    ) {
      setErrorMessage('longitude ຕ້ອງຢູ່ລະຫວ່າງ -180 - 180');
      return false;
    }
    if (!selectedMerchant && !imageFile) {
      setErrorMessage('Please select an image.');
      return false;
    }
    // if (!/^\d+$/.test(phone.current?.value) || phone.current?.value.length !== 8) {
    //   setErrorMessage('Phone number must contain only digits and be exactly 8 digits long.');
    //   return false;
    // }
    if (!selectedMerchant && !imageBannerFile) {
      setErrorMessage('Please select an banner image.');
      return false;
    }
    setErrorMessage('');
    return true;
  };

  const handleOpenForm = (e: any) => {
    e.preventDefault();
    if (handleValidateForm()) {
      setOpenConfirm(!openConfirm);
    }
  };

  const handleCloseConfirm = () => {
    setOpenConfirm(false);
  };

  const handleSubmit = () => {
    if (selectedMerchant?.id) {
      handleEditBranch();
      handleEditLocation();
    } else {
      handleAddBranch();
    }
  };

  const handleAddBranch = async () => {
    try {
      setLoadingConfirmButton(true);
      const input = {
        image: generateImageFileNameWithRandomName(imageFile),
        createByName: createByUser,
        nameEn: nameEn.current?.value,
        nameLa: nameLa.current?.value,
        abbreviateName: abbName.current?.value,
        merchantNo: merchantNo.current?.value,
        merchantCode: merchantCode.current?.value,
        provice: province.current?.value,
        district: district.current?.value,
        village: village.current?.value,
        phone: phone.current?.value,
        company: tabMerchant,
        deliveryFeeId: deliveryFeeValue,
      };
      await axios.post(
        `${MERCHANT_STORE_CREATE}?latitude=${latitude.current.value}&logtitude=${longitude.current.value}`,
        input,
        {
          headers: {
            type: 'Point',
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      );
      onClose();
      await onfetch();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmButton(false);
      setOpenConfirm(false);
    }
  };

  const handleEditBranch = async () => {
    try {
      setLoadingConfirmButton(true);
      const formData: any = new FormData();

      if (nameEn.current?.value) {
        formData.append('nameEn', nameEn.current.value);
      }

      if (nameLa.current?.value) {
        formData.append('nameLa', nameLa.current.value);
      }

      if (abbName.current?.value) {
        formData.append('abbreviateName', abbName.current.value);
      }

      if (merchantCode.current?.value) {
        formData.append('merchantCode', merchantCode.current.value);
      }

      if (merchantNo.current?.value) {
        formData.append('merchantNo', merchantNo.current.value);
      }

      if (province.current?.value) {
        formData.append('provice', province.current.value);
      }

      if (district.current?.value) {
        formData.append('district', district.current.value);
      }

      if (village.current?.value) {
        formData.append('village', village.current.value);
      }

      if (phone.current?.value) {
        formData.append('phone', phone.current.value);
      }

      formData.append('company', tabMerchant);
      formData.append('isActive', ban);

      if (deliveryFeeValue) {
        formData.append('deliveryFeeId', deliveryFeeValue);
      }

      if (imageFile) {
        formData.append('image', generateImageFileNameWithRandomName(imageFile));
      }

      if (imageBannerFile) {
        formData.append('imageBanner', generateImageFileNameWithRandomName(imageBannerFile));
      }

      await axios.patch(MERCHANT_STORE_UPDATE + selectedMerchant.id, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      onClose();
      await onfetch();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmButton(false);
      setOpenConfirm(false);
    }
  };

  const handleEditLocation = async () => {
    try {
      setLoadingConfirmButton(true);
      await axios.post(
        `${MERCHANT_STORE_UPDATE_LOCATION + selectedMerchant.id}&logtitude=${
          longitude.current.value
        }&latitude=${latitude.current.value}`,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Accept: 'multipart/form-data',
          },
        }
      );
      onfetch();
    } catch (error: any) {
      try {
        const getErrorMessage: string = error.response.data.message;
        setErrorMessage(getErrorMessage);
      } catch (err) {
        setErrorMessage(t('Server error please try again') || '');
      }
    } finally {
      setLoadingConfirmButton(false);
      setOpenConfirm(false);
    }
  };

  const handleGetDeliveryFee = async () => {
    try {
      const resDeliveryFee = await axios.get(FIND_MANY_DELIVERY_FEE);
      if (resDeliveryFee?.data?.data.length > 0) {
        setDeliveryFeeData(resDeliveryFee?.data?.data);
        // setDeliveryFeeValue(resDeliveryFee?.data?.data?.id);
      }
    } catch (err) {}
  };

  const filterDeliveryFee = deliveryFeeData?.filter(
    (data: DeliveryFeeModel) => data.id === deliveryFeeValue
  );

  useEffect(() => {
    handleGetDeliveryFee();
  }, []);

  useEffect(() => {
    if (selectedMerchant) {
      setImageToShow(IMAGE_MERCHANT_URL + selectedMerchant?.image?.url);
      setImageBannerToShow(IMAGE_MERCHANT_URL + selectedMerchant?.imageBanner?.url);
      nameEn.current.value = selectedMerchant?.nameEn;
      nameLa.current.value = selectedMerchant?.nameLa;
      abbName.current.value = selectedMerchant?.abbreviateName;
      merchantNo.current.value = selectedMerchant?.merchantNo;
      latitude.current.value = selectedMerchant?.location.coordinates[1].toString();
      longitude.current.value = selectedMerchant?.location.coordinates[0].toString();
      province.current.value = selectedMerchant?.provice;
      district.current.value = selectedMerchant?.district;
      village.current.value = selectedMerchant?.village;
      phone.current.value = selectedMerchant?.phone;
      merchantCode.current.value = selectedMerchant?.merchantCode;
      setTabMerchant(selectedMerchant?.company as MerchantEnum);
      setBan(selectedMerchant?.isActive);
      setDeliveryFeeValue(selectedMerchant?.deliveryFee?.id);
    }
  }, [selectedMerchant]);

  useEffect(() => {
    if (provinceValue && dataProvinceFromJson?.length > 0) {
      const districtData = dataProvinceFromJson.filter(
        (item) => item?.provinceNameLA === provinceValue
      )[0]?.districts;

      if (districtData?.length > 0) {
        setDistrictsData(districtData);
        setDistrictsValue(districtData[0]?.districtNameLA || null!);
      } else {
        setDistrictsData(districtData);
        setDistrictsValue(null!);
      }
      if (selectedMerchant) {
        setDistrictsValue(selectedMerchant?.district);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [provinceValue]);

  return {
    onBan,
    ban,
    handleOpenForm,
    imageToShow,
    handleSelectImage,
    openConfirm,
    nameEn,
    nameLa,
    abbName,
    merchantNo,
    latitude,
    longitude,
    province,
    district,
    village,
    phone,
    handleSubmit,
    loadingConfirmButton,
    handleCloseConfirm,
    errorMessage,
    handleReset,
    merchantCode,
    handleSelectedCompany,
    tabMerchant,
    handleSelectBannerImage,
    imageBannerToShow,
    deliveryFeeData,
    handleSelectDeliveryFee,
    deliveryFeeValue,
    filterDeliveryFee,
    imageBannerFile,
  };
};
